import React, { useEffect, useState } from "react";
import { DELETE_ALL } from "../text-data";
import { ReloadBlackSvg } from "./Assets";

const DEFAULT_MIN_HEIGHT = 28; // Adjust as needed

function CountableInput({
  defaultValue,
  textAreaRef,
  onChange,
  maxLength = 50,
  placeholder
}) {
  const [text, setText] = useState(defaultValue || "");
  // const textAreaRef = ref;
  const handleChange = (event) => {
    setText(event.target.value);
    onChange && onChange(event.target.value);
  };

  const characterCount = text.length;

  return (
    <div className="flex gap-2.5 w-full">
      <input
        ref={textAreaRef}
        value={text}
        onChange={handleChange}
        style={{
          border: "none",
          width: "100%",
          resize: "none",
          height: DEFAULT_MIN_HEIGHT,
        }}
        placeholder={placeholder}        
      />
      <div className="flex justify-between pt-[7px]">
        <span className="text-xs">
          <b
            className={
              characterCount > maxLength ? "text-red" : "text-darkblue"
            }
          >
            {characterCount}
          </b>
          <span style={{ color: "#B7BDCA" }}>/{maxLength}</span>
        </span>
      </div>
    </div>
  );
}

export default CountableInput;
